export default function DSA_Insertion_Sort() {
  return <div>DSA_Insertion_Sort Component</div>;
}
